import type * as lazyIndex from './lazyIndex';
import { LazyModule, LazyAction } from 'owa-bundling-light';

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule(
    () => import(/* webpackChunkName: "PlacesPostBoot" */ './lazyIndex'),
    { name: 'PlacesPostBoot' }
);

export const lazySetupPlacesPostRender: LazyAction<
    typeof lazyIndex.setupPlacesPostRender,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.setupPlacesPostRender);
